import { render, staticRenderFns } from "./MisClientesView.vue?vue&type=template&id=3e5d8ddf"
import script from "./MisClientesView.vue?vue&type=script&lang=js"
export * from "./MisClientesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports